export default __webpack_public_path__ + "static/media/back-icon.95dafd02.svg";